import { render, staticRenderFns } from "./MasterPayer.vue?vue&type=template&id=f2c1936a&"
import script from "./MasterPayer.vue?vue&type=script&lang=js&"
export * from "./MasterPayer.vue?vue&type=script&lang=js&"
import style0 from "./MasterPayer.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports